import type { FC } from "react";

import * as CSS from "./checkbox-input.styles";
import type { CheckboxInputProps } from "./checkbox-input.types";

const CheckboxInput: FC<CheckboxInputProps> = ({
	checked,
	id,
	label,
	onCheck,
}) => {
	return (
		<CSS.Wrapper data-testid={id}>
			<CSS.Checkbox
				id={`checkbox-${id}`}
				type="checkbox"
				checked={checked}
				onChange={() => onCheck(!checked)}
			/>
			<CSS.Label htmlFor={`checkbox-${id}`}>{label}</CSS.Label>
		</CSS.Wrapper>
	);
};

export default CheckboxInput;
